export default __webpack_public_path__ + "static/0074-d8292515c273443467cbb17f89911bfc.png";